import React, { useEffect, useRef, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/tr';

import { useNavigate } from "react-router-dom";

import { useQueryClient } from '@tanstack/react-query';
import useLocalStorage from '../hooks/useLocalStorage';
import { useValidateQuery } from '../hooks/useValidateQuery';
import { CustomSnackbar } from '../components/CustomSnackbar';
import NavigationBar from '../components/NavigationBar';
import { useRefreshQuery } from '../components/Login/useRefreshQuery';
import { TablePagination, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useWhatsappChatQuery } from '../components/Chat/hooks/useWhatsappChatQuery';
import { WhatsappChatComponent } from '../components/Chat/WhatsappChatComponent';
import { useSocket } from '../components/contextProviders/SocketProvider';

import RBKIcon from '../resources/icon.png';
import { usePatientsQuery } from '../hooks/usePatientsQuery';

import { Popper } from '@mui/material/';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { useUpdateConvCaseMutation } from '../components/Chat/hooks/useUpdateConvCaseMutation';
import TextLanguage from '../data/TextLanguage.json';

import { userTypesRBK } from '../data/userTypes';
import { WhatAppConversationButton } from '../components/Chat/WhatAppConversationButton';
import { WhatsappConversationCaseSelection } from '../components/Chat/WhatsappConversationCaseSelection';


export const StyledPopper = styled(Popper)(({ theme }) => ({
    [`& .${autocompleteClasses.listbox}`]: {
        boxSizing: 'border-box',
        background: 'transparent',
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
}));

const Paginator = styled(TablePagination)({
    display: 'flex',
    margin: '0',
    width: 'auto',
    height: '100%',
    background: 'none !important',
});
export function ChatPage() {



    const [lang, setlang] = useLocalStorage('lang', 'enUS');

    const queryClient = useQueryClient();


    const [snackbarStatus, setsnackbarStatus] = useState({
        open: false,
        message: '',
        severity: 'success'
    });


    // Context Menu End

    const navigate = useNavigate();




    const validateQuery = useValidateQuery();
    const refreshQuery = useRefreshQuery();

    const opMode = userTypesRBK.includes(validateQuery.data?.data?.userID);

    useEffect(() => {
        if (refreshQuery.isError && refreshQuery.failureCount >= 3) {
            console.log('Refresh Token Expired');
            queryClient.clear();
            navigate('/');
        } else if (refreshQuery.isError && refreshQuery.error?.response?.status === 403) {
            console.log('Refresh Token Expired');
            queryClient.clear();
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshQuery, refreshQuery.isError, refreshQuery.failureCount])

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const onPageChange = (e, newPage) => {
        setPage(newPage);
    }
    const handleChangeRowsPerPage = (e) => {
        setPageSize(parseInt(e.target.value, 10));
        setPage(0);
    };

    const { data: whatsappQueryData, isSuccess } = useWhatsappChatQuery({ limit: pageSize, page: page });

    useEffect(() => {
        if (validateQuery.isSuccess) {
            if (!userTypesRBK.includes(validateQuery.data.data?.userID)) {
                navigate("/");
            }
        }
    }, [validateQuery.data, validateQuery.isSuccess, validateQuery.isError, navigate])

    const [selectedChat, setSelectedChat] = useState(0);

    const socket = useSocket();
    const [notificationState, setNotificationState] = useState(true);

    useEffect(() => {

        if (notificationState && Notification.permission !== "granted") {
            Notification.requestPermission();
        }

    }, [notificationState])

    const invalidateDebounceRef = useRef(null);
    useEffect(() => {

        socket.on('update', (msg) => {

            console.log('socket', msg);


            invalidateDebounceRef.current && clearTimeout(invalidateDebounceRef.current);
            invalidateDebounceRef.current = setTimeout(() => {
                queryClient.invalidateQueries({ queryKey: ['messageData'], refetchType: 'active' }, { cancelRefetch: false });
            }, 250);

            if (msg.type === 'NewMessage') {

                if ('Notification' in window && notificationState) {

                    Notification.requestPermission().then(function (permission) {

                        if (permission === 'granted') {
                            const contentType = msg?.value?.content?.type;

                            var notification = new Notification(`+${msg?.value?.from}`, {
                                body: `${contentType === 'text' ? msg?.value?.content?.text : 'Media'}`,
                                icon: RBKIcon,
                                silent: true
                            });


                            notification.onclick = function () {

                                navigate('/chat');
                                const findChat = whatsappQueryData?.data?.findIndex((chat) => chat.conversation === msg?.value?.from) || 0;
                                setSelectedChat(findChat);

                                window.focus();
                            };

                        } else {
                            console.log('Notification permission denied');
                        }
                    });
                } else {

                    console.log('Browser does not support notifications');
                }
            }
        })

        return () => {
            socket.off('update');
        }

    }, [socket, navigate, setSelectedChat, whatsappQueryData?.data]);



    return (

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">

            <div className="App-main">

                <CustomSnackbar
                    snackbarStatus={snackbarStatus}
                    setsnackbarStatus={setsnackbarStatus}
                />

                <NavigationBar
                    currentPage='chat'
                    lang={lang}
                    opMode={opMode}
                    notificationState={notificationState}
                    setNotificationState={setNotificationState}
                />




                <div className='ChatPageContainer'>
                    <div className='ChatSelectionTable'>


                        <div className='ChatTableHeader'>
                            <Typography variant='h4' sx={{ fontSize: '1.4rem', fontWeight: 'bold', color: 'white', pointerEvents: 'none', userSelect: 'none' }}>
                                {TextLanguage["IncomingMessages"][lang]}
                            </Typography>
                        </div>



                        {isSuccess &&
                            <div className='ChatConversationButtonColumn' >
                                {whatsappQueryData?.data.map((messageData, index) => {
                                    return (
                                        <WhatAppConversationButton
                                            index={index}
                                            key={index}
                                            selectedChat={selectedChat}
                                            setSelectedChat={setSelectedChat}
                                            messageData={messageData}
                                        />
                                    )
                                })}
                            </div>}

                        <div className='ChatTableFooter'>
                            {
                                //Paginator
                            }
                            <Paginator

                                sx={{ width: 'auto' }}
                                count={100}
                                page={page}
                                onPageChange={onPageChange}
                                rowsPerPage={pageSize}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage={TextLanguage["RowsPerPage"][lang]}
                                rowsPerPageOptions={[15]}
                                component="div"
                                showFirstButton={true}
                                showLastButton={true}
                            />

                        </div>



                    </div>
                    <div style={{ width: '100%', height: '100%', }}>
                        {isSuccess &&
                            <WhatsappChatComponent
                                selectedChat={selectedChat}
                                setsnackbarStatus={setsnackbarStatus}
                                messageQueryData={whatsappQueryData}

                            />
                        }
                    </div>


                    <WhatsappConversationCaseSelection
                        lang={lang}
                        setsnackbarStatus={setsnackbarStatus}
                        whatsappQueryData={whatsappQueryData}
                        selectedChat={selectedChat}
                    />





                </div>


            </div>
        </LocalizationProvider>
    );
}





